<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .subsetting__container
            .setting__title Трафик
            el-switch(v-model="active" @change="updateActiveStatus()")
        .setting__container
          .setting__title Лимиты
          .subsetting__container
            .setting__title Минимальный лимит
            el-input(v-model="min_amount" size="mini" type="number")
            el-button(type="success" size="mini" @click="updateExchangeLimit('min_amount')") Изменить
          .subsetting__container
            .setting__title Максимальный лимит
            el-input(v-model="max_amount" size="mini" type="number")
            el-button(type="success" size="mini" @click="updateExchangeLimit('max_amount')") Изменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  EDIT_EXCHANGE_SETTINGS,
  LOAD_EXCHANGE_SETTINGS,
} from '@/store/const/exchange';

export default {
  name: 'ExchangeSettings',
  data() {
    return {
      active: false,
      min_amount: 0,
      max_amount: 0,
    }
  },
  async mounted() {
    this.loadAndSetExchangeSettings();
  },
  computed: {
    ...mapGetters([
      'loading',
    ]),
    isLoading() {
      return this.loading(LOAD_EXCHANGE_SETTINGS) === 'loading';
    },
  },
  methods: {
    ...mapActions('exchange', {
      getExchangeSettings: LOAD_EXCHANGE_SETTINGS,
      editExchangeSetting: EDIT_EXCHANGE_SETTINGS,
    }),
    async loadAndSetExchangeSettings() {
      const request = await this.getExchangeSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
        }
      }
    },
    async updateActiveStatus() {
      this.$confirm(`Вы уверены, что хотите ${this.active ? 'включить' : 'отключить'} обменку?`, 'Подтверждение').then(async () => {
        const request = await this.editExchangeSetting({ active: this.active });
        if (request.success) {
          this.$message.success('Настройки успешно обновлены');
        } else {
          this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
          this.active = !this.active;
        }
      }).catch(() => {
        this.$message.info('Изменение статуса отменено');
        this.active = !this.active;
      });
    },
    async updateExchangeLimit(limit_type) {
      this.$confirm(`Вы уверены, что хотите изменить лимит?`, 'Подтверждение').then(async () => {
        const request = await this.editExchangeSetting({ [limit_type]: this[limit_type] });
        if (request.success) {
          this.$message.success('Настройки успешно обновлены');
        } else {
          this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
          this.disableNewUsers = !this.disableNewUsers;
        }
      }).catch(() => {
        this.$message.info('Изменение настройки лимитов отменено');
        this.disableNewUsers = !this.disableNewUsers;
      });
    },
  }
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 240px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f
}

.setting__container.general {
  width: 480px;
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.setting__value {
  margin-top: 10px;
}

.balance__btn {
  margin-top: 10px;
}

.subsetting__container {
    margin-bottom: 10px;
}

.subsetting__container:last-child {
    margin-bottom: 0;
}

.payment-system-edit {
    cursor: pointer;
}

.payment-system-edit:hover {
    text-shadow: 1px 1px 1px #d9d9d9;
}

.dialog-input__container {
    margin-bottom: 10px;
}

.dialog-input__container:last-child {
    margin-bottom: 0;
}

.dialog-finish__buttons {
    margin-top: 10px;
}
</style>
